import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';
import cnames from 'classnames';
import Button from '../../../Button';
import withNextAction from '../../../utils/withNextAction';
import Box from '../../../Box';
import styles from './style.module.css';

const messages = defineMessages({
  sellArt: {
    id: 'react.headerAndFooter.components.HeaderLinks.sellArt',
    defaultMessage: 'Sell your art',
  },
  login: {
    id: 'react.headerAndFooter.components.HeaderLinks.login',
    defaultMessage: 'Login',
  },
  signup: {
    id: 'react.headerAndFooter.components.HeaderLinks.signup',
    defaultMessage: 'Signup',
  },
});

const HeaderLinks = ({
  intl,
  baseUrl,
  doLogin,
  doSignup,
  isDesktop,
  isLoggedIn,
  hasHamburgerMenu,
  redirectUrl,
}: any) => {
  if (!isDesktop || isLoggedIn) return null;

  const baseLinkProps = {
    rel: 'nofollow',
  };

  const loginProps = {
    ...baseLinkProps,
    onClick(ev?: any) {
      if (doLogin) {
        return doLogin(ev);
      }

      // Generate link in onClick to prevent server-side rendering issues
      (window as any).location.href = withNextAction(`${baseUrl}/auth/login`, redirectUrl);
      return ev.preventDefault();
    },
    href: `${baseUrl}/auth/login`,
  };

  const signupProps = {
    ...baseLinkProps,
    onClick(ev?: any) {
      if (doSignup) {
        return doSignup(ev);
      }

      // Generate link in onClick to prevent server-side rendering issues
      (window as any).location.href = withNextAction(`${baseUrl}/signup`, redirectUrl);
      return ev.preventDefault();
    },
    href: `${baseUrl}/signup`,
  };

  return (
    <>
      <Box className={cnames({ [styles.hideForHamburger]: hasHamburgerMenu })}>
        <Button href={`${baseUrl}/about/selling`}>
          {intl.formatMessage(messages.sellArt)}
        </Button>
      </Box>
      <Button
        {...loginProps}
        data-testid="ds-header-login-action"
      >
        {intl.formatMessage(messages.login)}
      </Button>
      <Box className={cnames({ [styles.hideForHamburger]: hasHamburgerMenu })}>
        <Button
          {...signupProps}
          data-testid="ds-header-signup-action"
        >
          {intl.formatMessage(messages.signup)}
        </Button>
      </Box>
    </>
  );
};

(HeaderLinks as any).propTypes = {
  intl: PropTypes.shape({}).isRequired,
  baseUrl: PropTypes.string.isRequired,
  doLogin: PropTypes.func,
  doSignup: PropTypes.func,
  hasHamburgerMenu: PropTypes.bool,
  redirectUrl: PropTypes.string,
};


(HeaderLinks as any).defaultProps = {
  doLogin: null,
  doSignup: null,
};

(HeaderLinks as any).displayName = 'HeaderLinks';

export default HeaderLinks;
